import { DynamicDialogService } from '@common/ui/frontend-shared/dynamic-dialog';
import { loadAndShowConsole } from './console-loader';
import * as i0 from "@angular/core";
import * as i1 from "@common/ui/frontend-shared/dynamic-dialog";
function ConsoleToggleComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵdomElementStart(0, "button", 1);
    i0.ɵɵdomListener("click", function ConsoleToggleComponent_Conditional_0_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggle());
    });
    i0.ɵɵtext(1, "DevConsole");
    i0.ɵɵdomElementEnd();
  }
}
export let ConsoleToggleComponent = /*#__PURE__*/(() => {
  class ConsoleToggleComponent {
    constructor(dialogService) {
      this.dialogService = dialogService;
      this.show = false;
      if (!IS_PRODUCTION) this.show = true;
    }
    toggle() {
      loadAndShowConsole(this.dialogService);
    }
    static {
      this.ɵfac = function ConsoleToggleComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ConsoleToggleComponent)(i0.ɵɵdirectiveInject(i1.DynamicDialogService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: ConsoleToggleComponent,
        selectors: [["ng-component"]],
        features: [i0.ɵɵProvidersFeature([DynamicDialogService])],
        decls: 1,
        vars: 1,
        consts: [[1, "debug-btn"], [1, "debug-btn", 3, "click"]],
        template: function ConsoleToggleComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, ConsoleToggleComponent_Conditional_0_Template, 2, 0, "button", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.show ? 0 : -1);
          }
        },
        styles: [".debug-btn[_ngcontent-%COMP%]{position:fixed;bottom:10px;right:10px;z-index:9999}\n\n/*# sourceMappingURL=console-toggle.component.ts-angular-inline--50.css.map*/"]
      });
    }
  }
  return ConsoleToggleComponent;
})();